import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Due from '../../../../assets/img/due-date.png';
import Percentage from '../../../../assets/img/discount.png';
import Income from '../../../../assets/img/salary.png';
import Book from '../../../../assets/img/book.png';
import ReminderModal from '../dashboard/_reminderModal';

export default function TopMetricDetails({ defaulters, monthIncome, textColorClass, landlordCurrentOccupancy, textColorClassOccupancy, dataMetrics, }) {
    const [isReminderModalOpen, setIsReminderModalOpen] = useState(false);
    const { id } = useParams()
    const handleReminderModalOpen = () => {
        setIsReminderModalOpen(true);
    };

    const handleSendReminders = (reminderData) => {
        console.log('Sending reminder:', reminderData);
        setIsReminderModalOpen(false);
    };

    const [messageTemplates] = useState([]);

    const cards = [
        {
            title: "Rent Due",
            value: dataMetrics ? dataMetrics.rent_due?.toLocaleString() : 0,
            icon: Due,
            bgColor: "#c0dedc",
            shadowColor: "#c0dedc",
            textColor: "text-gray-800",
            buttons: null
        },
        {
            title: "Defaulters",
            value: defaulters ? defaulters.defaulters?.toLocaleString() : 0,
            icon: Book,
            bgColor: "#e6def1",
            shadowColor: "#e6def1",
            textColor: "text-gray-800",
            buttons: defaulters?.defaulters > 0 && (
                <div className="mt-1">
                    <button
                        className="bg-red-600 text-white text-sm p-2 rounded me-4"
                        onClick={handleReminderModalOpen}
                    >
                        Send Reminders
                    </button>
                    <Link to={`/defaulters-list?apartment_id=${id}`} className="no-underline ml-2">
                        <button className="bg-purple-700 text-white text-sm p-2 rounded">
                            View
                        </button>
                    </Link>
                </div>
            )
        },
        {
            title: "Income",
            value: dataMetrics ? dataMetrics.rent_paid?.toLocaleString() : 0,
            icon: Income,
            bgColor: "#f1eee8",
            shadowColor: "#f1eee8",
            textColor: "text-gray-800",
            buttons: null
        },
        {
            title: "Occupancy",
            value: `${dataMetrics ? dataMetrics.occupancy_percentage : 0}%`,
            icon: Percentage,
            bgColor: "#f0dfdf",
            shadowColor: "#f0dfdf",
            textColor: "text-gray-800",
            buttons: null
        }
    ];

    return (
        <div className="w-full mt-3">
            {/* Cards Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 px-2">
                {cards.map((card, index) => (
                    <div
                        key={index}
                        style={{ minHeight: '20px', backgroundColor: card.bgColor, boxShadow: `${card.shadowColor}  10px 11px 25px 1px` }}
                        className={`rounded-3xl ${card.textColor} p-4  transition-all`}
                    >
                        <div className="flex items-start">
                            <img
                                src={card.icon}
                                alt={card.title}
                                className="p-3 bg-white rounded-full w-16 h-16 mr-3"
                            />
                            <div className="flex-1">
                                <h3 className="text-sm font-medium">{card.title}</h3>
                                <p className="text-2xl font-bold mt-1">{card.value}</p>
                                {card.buttons}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Reminder Modal */}
            <ReminderModal
                isOpen={isReminderModalOpen}
                onClose={() => setIsReminderModalOpen(false)}
                reminderType='apartment'
                apartment={id}
            />
        </div>
    );
};